import React from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import { makeStyles } from "@material-ui/core";
import CustomAlert from "./CustomAlert";

const useStyles = makeStyles({
  h3: {
    marginBottom: 0,
    marginTop: 0,
  },
  outerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  p: {
    marginTop: "8px",
  },
  refreshIcon: {
    cursor: "pointer",
    marginRight: "16px",
  },
});

const VersionAlert = () => {
  const classes = useStyles();

  return (
    <CustomAlert noIcon severity="info">
      <div className={classes.outerContainer}>
        <RefreshIcon className={classes.refreshIcon} onClick={() => document.location.reload()} />
        <div>
          <h3 className={classes.h3}>New Version of LEAP Available!</h3>
          <p className={classes.p}>
            Please save your current data and refresh the browser to ensure you are using the newest version.
          </p>
        </div>
      </div>
    </CustomAlert>
  );
};

export default VersionAlert;
